import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../../stores/Context';
import FlecheRevenirSvg from '../../../boiteAOutils/SVG/FlecheRevenirSvg';

/**
 * WidgetRSPBtn — Sidebar navigation for RSP widget
 * Pattern: returns ONLY <div className="navBarWidgetBtnContent">
 * SidebarWidgets.js handles the widgetsNavBar wrapper.
 */
const WidgetRSPBtn = observer(() => {
    const { RspStore, uiStore } = useStores();

    const isDetail = RspStore.view && RspStore.view !== 'liste';

    const handleGoHome = () => { uiStore.backHome(); };

    const etapes = [
        { id: 'etape1', label: 'QQOQCCP' },
        { id: 'etape2', label: 'Causes' },
        { id: 'etape3', label: 'Solutions' },
        { id: 'etape4', label: 'Matrice' },
        { id: 'etape5', label: 'Validation' },
    ];

    return (
        <div className="navBarWidgetBtnContent">

            {/* Bouton Retour — même taille que PA */}
            <div className="widgetsNavBarContentIcons" onClick={handleGoHome} title="Retour">
                <FlecheRevenirSvg width={28} height={28} couleur="#FBFDFE" />
                <span className="widgetsNavBarContentIconsText">Retour</span>
            </div>

            {/* Séparateur */}
            <svg viewBox="0 0 84 4" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"5em"}}>
                <rect width="84" height="4" rx="2" fill="#FBFDFE" fillOpacity="0.2"/>
            </svg>

            {/* Bouton Nouveau problème */}
            <div
                className="widgetsNavBarContentIcons"
                onClick={() => RspStore.ouvrirFormCreation()}
                title="Nouveau problème"
            >
                <div className="navBarWidgetBtnAdd">
                    <svg width="24" height="24" viewBox="0 0 40 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 4.875V34.125" stroke="white" strokeWidth="4" />
                        <path d="M5.376 19.5H34.624" stroke="white" strokeWidth="4" />
                    </svg>
                </div>
                <span className="widgetsNavBarContentIconsText">Nouveau</span>
            </div>

            {/* Bouton Liste */}
            <div
                className={`widgetsNavBarContentIcons${RspStore.view === 'liste' ? ' active' : ''}`}
                onClick={() => RspStore.goToListe()}
                title="Liste des problèmes"
            >
                <svg style={{width: "2.2em"}} viewBox="0 0 24 24" fill="none" stroke="#FBFDFE" strokeWidth="2" strokeLinecap="round">
                    <line x1="8" y1="6" x2="21" y2="6"/>
                    <line x1="8" y1="12" x2="21" y2="12"/>
                    <line x1="8" y1="18" x2="21" y2="18"/>
                    <line x1="3" y1="6" x2="3.01" y2="6"/>
                    <line x1="3" y1="12" x2="3.01" y2="12"/>
                    <line x1="3" y1="18" x2="3.01" y2="18"/>
                </svg>
                <span className="widgetsNavBarContentIconsText">Liste</span>
            </div>

            {/* Étapes (visibles seulement si un problème est actif) */}
            {isDetail && (
                <>
                    <svg viewBox="0 0 84 4" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"5em"}}>
                        <rect width="84" height="4" rx="2" fill="#FBFDFE" fillOpacity="0.2"/>
                    </svg>
                    {etapes.map((etape, i) => (
                        <div
                            key={etape.id}
                            className={`widgetsNavBarContentIcons${RspStore.view === etape.id ? ' active' : ''}`}
                            onClick={() => RspStore.goToEtape(i + 1)}
                            title={etape.label}
                        >
                            <div style={{
                                width: 26, height: 26, borderRadius: '50%',
                                background: RspStore.view === etape.id ? '#00B0FF' : 'rgba(255,255,255,0.15)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 11, fontWeight: 700, color: '#FBFDFE',
                                border: RspStore.view === etape.id ? '2px solid #00B0FF' : '2px solid rgba(255,255,255,0.3)'
                            }}>
                                {i + 1}
                            </div>
                            <span className="widgetsNavBarContentIconsText">{etape.label}</span>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
});
export default WidgetRSPBtn;
